import { Separator } from '../../../components/separator'
import { useAppSelector } from '../../../redux/hook'
import { P2TextDescription } from 'react-bootstrap-common-script'
import { solicitorTypeItems } from '../../../utils/shared-dropdown'
import { Radio_Loan_Types } from '../../../utils/shared-radio'
import { Helpers } from '../../../utils/helper'
import { HoldingTypeTypeCode, LoanTypeCode } from '../../../utils/code-converter'
import { StageBConveyancing } from '../../../models/classes/stage-b/review-endorse.class'
import { ApplicationStep2 } from '../../../models/classes/ApplicationStep2.class'
import useIsMobile from '../../../hooks/use-is-mobile'
import MobileTableMobile, { MobileTableItemInterface } from '../../../components/mobile/mobile-table'
import { useCallback, useMemo } from 'react'
import { SolicitorTypeEnum } from '../../../models/enum/solicitor-type.enum'
import { convertRoleToStructureStatus } from '../../../utils/form-helper'
import { StructureStatusEnum } from '../../../models/enum/structure-status.enum'
import { MyInfoWithDOD } from '../../../models/polymer/MyInfo.model'


interface ReviewHouseholdStructureTableProps{
  enableMasking?:boolean;
  isMainOutgoing?: boolean;
  conveyancingValues?: StageBConveyancing;
  financialFormValues?: ApplicationStep2;
  headerSeparatorVariant?: "solid" | "dashed";
}
type solicitorType = "current" | "proposed";

function ReviewHouseholdStructureTable({enableMasking=false, headerSeparatorVariant="solid",...props}: ReviewHouseholdStructureTableProps) {
  const applicationStartFormData = useAppSelector(state => state.app.ApplicationStartSlice.formData);
  const applicationStep1FormData = useAppSelector((state) => state.app.ApplicationStep1Slice.formData);
  const applicationStep2FormData = useAppSelector((state) => state.app.ApplicationStep2Slice.formData);
  const applicationStep3FormData = useAppSelector((state) => state.app.ApplicationStep3Slice.formData);
  const isSoleOwnership = applicationStep1FormData.household.incoming_owners.length === 1;

  const proposedHoldingTypeTitle = isSoleOwnership ? "Sole Ownership" : HoldingTypeTypeCode.find(e => e.code === applicationStep3FormData.holding_type)?.description;
  const loanTypeDescription = Radio_Loan_Types.find(e => e.value === applicationStep2FormData.new_loan_type)?.description as string;

  const selectedLoanType = Radio_Loan_Types.find(e => e.value === props.financialFormValues?.new_loan_type)?.description;
  const selectedHoldingType = HoldingTypeTypeCode.find(e => e.code === props.conveyancingValues?.holding_type)?.description;


  const { isMobile } = useIsMobile();

  const hasExecutorAdministrator = useMemo(()=>{
    return applicationStartFormData.selected_hdb_property?.additional_roles.some(e=>{
      const roleStructureStatus = convertRoleToStructureStatus(e.role_name);
      return roleStructureStatus === StructureStatusEnum.executor || roleStructureStatus === StructureStatusEnum.administrator
    })
  },[applicationStartFormData.selected_hdb_property?.additional_roles])

  const executorAdministratorListing:MyInfoWithDOD[] = useMemo(()=>{
    let dataList:MyInfoWithDOD[] = [];
    if(hasExecutorAdministrator){
      applicationStartFormData.selected_hdb_property?.additional_roles.forEach(e=>{
        const roleStructureStatus = convertRoleToStructureStatus(e.role_name);
        if(roleStructureStatus === StructureStatusEnum.executor || roleStructureStatus === StructureStatusEnum.administrator){
          dataList.push(e);
        }
      })
    }
    return dataList;
  },[applicationStartFormData.selected_hdb_property?.additional_roles, hasExecutorAdministrator])


  const ConveyancingRowUnderSolicitorColumn = useCallback((type: solicitorType, enableMasking:boolean = false)=>{
    
    let solicitorTypeValue = props.conveyancingValues ? props.conveyancingValues[`${type}_solicitor_type`] : applicationStep3FormData[`${type}_solicitor_type`];
    let currentProposeValue = props.conveyancingValues ? props.conveyancingValues[type] : applicationStep3FormData[type];
    
    if(solicitorTypeValue === SolicitorTypeEnum.conveyancing_hdb_solicitor && applicationStep3FormData[type].hdb_solicitor.is_confirm){
      return <p>{Helpers.maskContent(`HDB (Conveyancing)`, enableMasking)}</p>
    }
    // else if(applicationStep3FormData[`${type}_solicitor_type`] === SolicitorTypeEnum.conveyancing_private_solicitor && applicationStep3FormData[type].conveyancing_private_solicitor.is_confirm){
    //     return <p>{Helpers.maskContent(`${applicationStep3FormData[type].conveyancing_private_solicitor.name_of_firm} (Conveyancing)`, enableMasking)}</p>
    // }
    else{
      if(currentProposeValue.conveyancing_private_solicitor.is_confirm) {
        return <p>{Helpers.maskContent(`${currentProposeValue.conveyancing_private_solicitor.name_of_firm} (Conveyancing)`, enableMasking)}</p>
      } else if(currentProposeValue.is_conveyancing_hdb && currentProposeValue.hdb_solicitor.is_confirm){
        return <p>HDB (Conveyancing)</p>
      }
    }
   
  },[applicationStep3FormData, props.conveyancingValues])

  const solicitorColumn = useCallback((type: solicitorType, enableMasking:boolean = false)=>{
    
    let selection_type = type === "current" ? applicationStep3FormData.current_solicitor_type : applicationStep3FormData.proposed_solicitor_type;
    let postfix_title = type === "current" ? "(Discharge of current loan)" : "(New mortgage loan)"
    let typeValue = applicationStep3FormData[type];
    if(props.conveyancingValues){
      selection_type = type === "current" ? props.conveyancingValues.current_solicitor_type : props.conveyancingValues.proposed_solicitor_type;
      typeValue = props.conveyancingValues[type];
    }
    
    

    if(selection_type && ((selection_type === SolicitorTypeEnum.hdb_solicitor && typeValue.hdb_solicitor.is_confirm) || (selection_type === SolicitorTypeEnum.private_solicitor && typeValue.private_solicitor.is_confirm))){
      
      const solicitor_type = selection_type === SolicitorTypeEnum.hdb_solicitor ? typeValue.hdb_solicitor : typeValue.private_solicitor;
      const sameRepresentation = solicitor_type.represented_same_solicitor;

      const primary_selection = selection_type === SolicitorTypeEnum.hdb_solicitor ? solicitorTypeItems.find(e => e.value === selection_type)?.title : typeValue.private_solicitor.name_of_firm;

      if(sameRepresentation){
        return <div>
            <p>{Helpers.maskContent(`${primary_selection}`, enableMasking)}</p>
          </div>
      }
      else{
        return <>
          <p>{Helpers.maskContent(`${primary_selection} ${postfix_title}`, enableMasking)}</p>
          {!enableMasking && ConveyancingRowUnderSolicitorColumn(type, enableMasking)}
        </>
      }

    }
    else if(selection_type && ((selection_type === SolicitorTypeEnum.conveyancing_hdb_solicitor && typeValue.hdb_solicitor.is_confirm) || (selection_type === SolicitorTypeEnum.conveyancing_private_solicitor && typeValue.conveyancing_private_solicitor.is_confirm))){
      return <>
        {ConveyancingRowUnderSolicitorColumn(type, enableMasking)}
      </>
    }
    else{
      if(type === "proposed" && props.isMainOutgoing){
        return <p className='ohc-household-structure-table-placeholder'>Pending proposed owner(s)</p>
      }
      return <p className='ohc-household-structure-table-placeholder'>You have not selected any lawyer to represent the {type} owners</p>
    }


   
   
  },[ConveyancingRowUnderSolicitorColumn, applicationStep3FormData, props.conveyancingValues, props.isMainOutgoing])




  const current_mobile_table_items = useMemo(()=>{
    const loan_type = LoanTypeCode.find(e => e.code === applicationStep2FormData?.current_loan_type)?.description ?? "";
    const holding_type = HoldingTypeTypeCode.find(e=>e.code === applicationStartFormData.selected_hdb_property?.holding_type)?.description ?? "";
    
    let obj_items:MobileTableItemInterface[] = [];
    
    if(hasExecutorAdministrator && applicationStartFormData.selected_hdb_property?.additional_roles){
      obj_items.push({ header:"Executor/Administrator", contents: applicationStartFormData.selected_hdb_property?.additional_roles.map(additional_role => `${additional_role.name} (${additional_role.role_name})`),  placeholder:"" });
    }
    obj_items.push({ header:"Owners", contents: applicationStep1FormData.household?.owners.map(e=>e.myinfo.name), placeholder:"You do not have any owner(s)" });
    obj_items.push({ header:"Occupiers", contents: applicationStep1FormData.household.occupiers.map(e=>e.myinfo.name), placeholder:"-" });
    obj_items.push({ header:"Loan", contents: [loan_type].filter(e=>e), placeholder:"-" });
    obj_items.push({ header:"Holding Type", contents: [holding_type].filter(e=>e), placeholder:"-" });
    obj_items.push({ header:"Lawyer", contents: [solicitorColumn("current") as any], placeholder:"-" });

    return obj_items;
  },[applicationStartFormData.selected_hdb_property?.additional_roles, applicationStartFormData.selected_hdb_property?.financing_info.current_loan_type, applicationStartFormData.selected_hdb_property?.holding_type, applicationStep1FormData.household.occupiers, applicationStep1FormData.household?.owners, hasExecutorAdministrator, solicitorColumn])

 
  const proposed_mobile_table_items = useMemo(()=>{

    const loan_type = !props.isMainOutgoing ? Helpers.maskContent(loanTypeDescription, enableMasking) ?? "" : selectedLoanType?.toString() ?? "";
    let holding_type;
    if (!props.isMainOutgoing) {
      holding_type = Helpers.maskContent(proposedHoldingTypeTitle, enableMasking) ?? "";
    } else {
      holding_type = proposedHoldingTypeTitle ? proposedHoldingTypeTitle : selectedHoldingType ?? "";
    }
    
    let obj_items:MobileTableItemInterface[] = [];
    
    if(hasExecutorAdministrator && applicationStartFormData.selected_hdb_property?.additional_roles){
      obj_items.push({ header:"Executor/Administrator", contents: applicationStartFormData.selected_hdb_property?.additional_roles.map(additional_role => `${additional_role.name} (${additional_role.role_name})`),  placeholder:"" });
    }
    obj_items.push({ header:"Owners", contents: applicationStep1FormData.household.incoming_owners.map(e=>e.myinfo.name), placeholder:"You have not added proposed owner(s)" });
    obj_items.push({ header:"Occupiers", contents: applicationStep1FormData.household.incoming_occupiers.map(e=>e.myinfo.name), placeholder:"-" });
    obj_items.push({ header:"Loan", contents: [loan_type].filter(e=>e), placeholder:"Pending proposed owner(s)" });
    obj_items.push({ header:"Holding Type", contents: [holding_type].filter(e=>e), placeholder:"Pending proposed owner(s)" });
    obj_items.push({ header:"Lawyer", contents: [solicitorColumn("proposed",enableMasking) as any], placeholder:"Pending proposed owner(s)" });

    return obj_items;
  },[applicationStartFormData.selected_hdb_property?.additional_roles, applicationStep1FormData.household.incoming_occupiers, applicationStep1FormData.household.incoming_owners, enableMasking, hasExecutorAdministrator, loanTypeDescription, proposedHoldingTypeTitle, props.isMainOutgoing, selectedHoldingType, selectedLoanType, solicitorColumn])

  const holdingTypeText = () => {
    if (selectedHoldingType && props.conveyancingValues?.is_holding_type_confirm) {
      return selectedHoldingType;
    } else if (proposedHoldingTypeTitle) {
      return proposedHoldingTypeTitle ? <p>{proposedHoldingTypeTitle}</p> : <p className='ohc-household-structure-table-placeholder'>Pending proposed owner(s)</p>
    }
  }

  return (
    <>
      <P2TextDescription color='#000' title='Ownership Change Details' />
      {/* Summary Table */}
      <div style={{ marginTop: 32 }}>
        <div style={{ marginBottom: 8 }}>
          <P2TextDescription size='20px' color='#000' title={"Summary"} />
        </div>
        {!isMobile && <div className='ohc-household-structure-table'>
          <div className='ohc-household-structure-table-header'>
            <div className='ohc-household-structure-table-column-1'></div>
            <div className='ohc-household-structure-table-column-2'>
              <p>Current household</p>
            </div>
            <div className='ohc-household-structure-table-column-2'>
              <p>Proposed household</p>
            </div>
          </div>
          {hasExecutorAdministrator && <>
            <Separator style={{margin:"16px 0"}}/>
            <div className='ohc-household-structure-table-content'>
              <div className='ohc-household-structure-table-column-1 ohc-household-structure-table-header' style={{display: "block"}}>
                <p>Executor/</p>
                <p>Administrator</p>
              </div>
              <div className='ohc-household-structure-table-column-2'>
                { executorAdministratorListing.map((additional_role,__index)=>{
                    const key = "additional_role"+__index;
                    return <p key={key}>{additional_role.name} ({additional_role.role_name})</p>
                  })
                }
              </div>
            </div>
          </>}
          <Separator style={{ margin: "16px 0" }}/>
          <div className='ohc-household-structure-table-content'>
            <div className='ohc-household-structure-table-column-1 ohc-household-structure-table-header'>
              <p>Owners</p>
            </div>

            <div className='ohc-household-structure-table-column-2'>
              {
                applicationStep1FormData.household?.owners.length > 0 
                ? (
                  applicationStep1FormData.household?.owners?.map(owner => {
                    return <p key={owner?.myinfo.uinfin}>{owner?.myinfo.name}</p>
                  })
                )
                : (
                  <p>-</p>
                )
              }
            </div>

            <div className='ohc-household-structure-table-column-2'>
              {
                applicationStep1FormData.household.incoming_owners?.map(owner => {
                  return <p key={owner?.myinfo.uinfin}>{owner.myinfo?.name}</p>
                })
              }
            </div>

          </div>
          <Separator style={{ margin: "16px 0" }} />
          <div className='ohc-household-structure-table-content'>
            <div className='ohc-household-structure-table-column-1 ohc-household-structure-table-header'>
              <p>Occupiers</p>
            </div>

            <div className='ohc-household-structure-table-column-2'>
              {
                applicationStep1FormData.household.occupiers && applicationStep1FormData.household.occupiers.length > 0 &&
                applicationStep1FormData.household.occupiers?.map(occupier => {
                  return <p key={occupier.myinfo.uinfin}>{occupier.myinfo.name}</p>
                })
              }
              {
                applicationStep1FormData.household.occupiers && applicationStep1FormData.household.occupiers.length <= 0 && <p>-</p>
              }
            </div>

            <div className='ohc-household-structure-table-column-2'>
              {
                applicationStep1FormData.household.incoming_occupiers?.map(occupier => {
                  return <p key={occupier?.myinfo.uinfin}>{occupier?.myinfo?.name}</p>
                })
              }
              {
                applicationStep1FormData.household?.incoming_occupiers && applicationStep1FormData.household?.incoming_occupiers?.length <= 0 && <p>-</p>
              }
            </div>

          </div>
          <Separator style={{ margin: "16px 0" }} />
          <div className='ohc-household-structure-table-content'>
            <div className='ohc-household-structure-table-column-1 ohc-household-structure-table-header'>
              <p>Loan</p>
            </div>

            <div className='ohc-household-structure-table-column-2'>
              <p>{LoanTypeCode.find(e => e.code === applicationStep2FormData?.current_loan_type)?.description}</p>
            </div>

            <div className='ohc-household-structure-table-column-2'>
              {!props.isMainOutgoing && <p>{Helpers.maskContent(loanTypeDescription, enableMasking)}</p>}
              {props.isMainOutgoing && <>{selectedLoanType ? <p>{selectedLoanType}</p> : <p className='ohc-household-structure-table-placeholder'>Pending proposed owner(s)</p>}</>}
            </div>

          </div>
          <Separator style={{ margin: "16px 0" }} />
          <div className='ohc-household-structure-table-content'>
            <div className='ohc-household-structure-table-column-1 ohc-household-structure-table-header'>
              <p>Holding Type</p>
            </div>

            <div className='ohc-household-structure-table-column-2'>
              <p>{HoldingTypeTypeCode.find(e=>e.code === applicationStartFormData.selected_hdb_property?.holding_type)?.description ?? "-"}</p>
            </div>

            <div className='ohc-household-structure-table-column-2'>
              {!props.isMainOutgoing && <p>{Helpers.maskContent(proposedHoldingTypeTitle, enableMasking)}</p>}
              {props.isMainOutgoing && <>{holdingTypeText()}</>}
            </div>

          </div>
          <Separator style={{ margin: "16px 0" }} />
          <div className='ohc-household-structure-table-content'>
            <div className='ohc-household-structure-table-column-1 ohc-household-structure-table-header'>
              <p>Lawyer </p>
            </div>

            <div className='ohc-household-structure-table-column-2'>
              {solicitorColumn("current")}
            </div>

            <div className='ohc-household-structure-table-column-2'>
              {solicitorColumn("proposed",enableMasking)}
            </div>

          </div>
        </div>}
        {isMobile && <>
          <MobileTableMobile title='Current household' items={current_mobile_table_items}/>
          <div style={{height:20}}></div>
          <MobileTableMobile title='Proposed household' items={proposed_mobile_table_items}/>
        </>}
      </div>
    </>
  )
}

export default ReviewHouseholdStructureTable